module.exports = __webpack_public_path__ + "media/images/frontend/linkedin-d5daf0f1bbfb2322dd09f4bf6b15f9bb.png";